export default __webpack_public_path__ + "static/media/leadbrix_icon_v1.f7b49756.png";